<script>
export default {
  name: "POModal",
  data() {
    return {
      tableData: null,
      loading: false,
    };
  },
  created() {},
  methods: {
    getData(poId) {
      this.loading = true;
      this.tableData = [];
      this.$store
        .dispatch("po/GetSinglePo", poId)
        .then((res) => {
          this.tableData = res.data;
          this.loading = false;
        })
        .catch(() => {
          this.showToast("Something went wrong - getting posted P.O", "error");
          this.loading = false;
        });
    },
  },
};
</script>
<template>
  <b-modal
    id="po-modal"
    title="Purchase Order"
    size="xl"
    title-class="font-20"
    hide-footer
    no-close-on-backdrop
  >
    <div
      class="h-50vh d-flex align-items-center justify-content-center"
      v-if="loading"
    >
      <div class="preloader-component me-2">
        <div class="status">
          <div class="spinner-chase w-25px h-25px">
            <div class="chase-dot"></div>
            <div class="chase-dot"></div>
            <div class="chase-dot"></div>
            <div class="chase-dot"></div>
            <div class="chase-dot"></div>
            <div class="chase-dot"></div>
          </div>
        </div>
      </div>
      <h5 class="mb-0">Loading...</h5>
    </div>
    <div
      class="h-50vh d-flex align-items-center justify-content-center"
      v-else-if="!tableData"
    >
      <h5 class="text-muted">
        <i class="fas fa-exclamation-triangle me-2"></i>No Data Found
      </h5>
    </div>
    <div v-else>
      <b-card no-body class="shadow-none position-relative">
        <b-card-header class="border" header-tag="header" role="tab">
          <div>
            <span>{{ tableData.poNumber }}</span>
            <h5 class="mb-0">{{ tableData.description }}</h5>
          </div>
        </b-card-header>
        <b-card-body class="border">
          <div class="row">
            <div class="col-md-4">
              <b>Supplier Details:</b>
              <div class="d-flex ms-4 mt-2">
                <i class="me-2">-</i
                ><span>Name: {{ tableData.rfqSupplier.supplier.name }}</span>
              </div>
              <div class="d-flex ms-4">
                <i class="me-2">-</i
                ><span
                  >Address: {{ tableData.rfqSupplier.supplier.address }}</span
                >
              </div>
              <div class="d-flex ms-4">
                <i class="me-2">-</i
                ><span
                  >Contact No.:
                  {{ tableData.rfqSupplier.supplier.contactNumber }}</span
                >
              </div>
              <div class="d-flex ms-4">
                <i class="me-2">-</i
                ><span
                  >Email:
                  <a href="javascript:void(0);">{{
                    tableData.rfqSupplier.supplier.email
                  }}</a></span
                >
              </div>
              <div
                class="d-flex ms-4"
                v-if="tableData.rfqSupplier.supplier.note"
              >
                <i class="me-2">-</i
                ><span>Note: {{ tableData.rfqSupplier.supplier.note }}</span>
              </div>
              <div class="mt-2">
                <div class="d-flex align-items-center">
                  <b class="me-2">Supplier Date Received:</b>
                  <span>{{
                    formatDate(new Date(tableData.poDateReceived))
                  }}</span>
                </div>
              </div>
              <div class="mt-2">
                <div class="d-flex align-items-center">
                  <b class="me-2">Expected Delivery:</b>
                  <span>{{
                    formatDate(new Date(tableData.expectedDelivery))
                  }}</span>
                </div>
              </div>
            </div>
            <div class="col-md-8 border-start border-3">
              <div class="ms-2">
                <div class="mb-2">
                  <b>Supplier Offers:</b>
                </div>
                <div>
                  <table width="100%">
                    <thead>
                      <tr class="border-bottom">
                        <th class="py-2 text-center" style="width: 60px">
                          Qty
                        </th>
                        <th class="py-2">Item Name</th>
                        <th class="py-2 text-center" style="width: 150px">
                          Unit Price
                        </th>
                        <th class="py-2 text-center" style="width: 150px">
                          Total Price
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="y in tableData.rfqSupplier.rfqSupplierOffers"
                        :key="y.id"
                        class="border-bottom"
                      >
                        <td class="py-2 align-top text-center">
                          {{ y.quantity }}
                        </td>
                        <td class="py-2 align-top">
                          <div>
                            {{ y.itemName }}
                          </div>
                          <small>{{ y.description }}</small>
                        </td>
                        <td class="py-2 align-top text-center">
                          {{ formatCurrency(y.unitCost) }}
                        </td>
                        <td class="py-2 align-top text-center">
                          {{ formatCurrency(y.unitCost * y.quantity) }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </b-card-body>
      </b-card>
    </div>
  </b-modal>
</template>

